<div id="forgot-password" class="float-panel lg-form-container" fxLayout="column">

    <div id="forgot-password-form-wrapper" class="lg-form-wrapper" fxLayout="column" fxLayoutAlign="center center" *ngcIfOnDom [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

        <div id="forgot-password-form" class="lg-form">

            <mat-progress-bar *ngIf="loading | async" class="loading-bar" color="accent" mode="indeterminate"></mat-progress-bar>

            <div class="logo" alt="logo"></div>

            <div class="title">{{isAccountSetup ? 'ACCOUNT SETUP' : 'RECOVER YOUR PASSWORD'}}</div>

            <form name="forgotPasswordForm" [formGroup]="forgotPasswordForm" novalidate (ngSubmit)="formSubmit()">

                <mat-form-field>
                    <input matInput placeholder="Email" formControlName="email">
                    <mat-error *ngIf="forgotPasswordFormErrors.email.required">
                        Email is required
                    </mat-error>
                    <mat-error *ngIf="!forgotPasswordFormErrors.email.required && forgotPasswordFormErrors.email.email">
                        Please enter a valid email address
                    </mat-error>
                </mat-form-field>

                <button mat-raised-button class="submit-button" color="accent"
                        aria-label="SEND RESET LINK" [disabled]="forgotPasswordForm.invalid">
                    {{isAccountSetup ? 'SEND LINK' : 'SEND RESET LINK'}}
                </button>
            </form>

            <div class="login" fxLayout="row" fxLayoutAlign="center center">
                <a class="link" [routerLink]="'/'">Go back to sign in page</a>
            </div>

        </div>

    </div>

    <ngc-footer-page *ngcIfOnDom [textColor]="'white'"></ngc-footer-page>

</div>
